import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

export const ImageBlock = styled(Box).attrs({
  pad: 'spacing4',
})`
  position: absolute;
  top: -24px;
  left: 50%;
  margin-left: -62px;
  width: 124px;
  height: 124px;
  box-sizing: border-box;
  z-index: 1;
  transition: top 0.2s ease;
  cursor: pointer;

  &:hover {
    top: -32px;
  }
`;

export const StackedImageBlock = styled(Box)`
  position: absolute;
  top: -24px;
  left: 50%;
  margin-left: -62px;
  width: 124px;
  height: 124px;
  box-sizing: border-box;
  z-index: 1;
  transition: top 0.2s ease;
  cursor: pointer;

  &:hover {
    top: -32px;
  }
`;

interface StackCardProps {
  layer: 0 | 1 | 2;
}

export const StackCard = styled(Box).attrs({
  pad: 'spacing4',
})<StackCardProps>`
  position: absolute;
  width: 124px;
  height: 124px;
  box-sizing: border-box;

  ${({ layer }) =>
    layer === 0 &&
    `
    top: 8px;
    left: 8px;
    z-index: 1;
  `}

  ${({ layer }) =>
    layer === 1 &&
    `
    top: 4px;
    left: 4px;
    z-index: 2;
  `}

  ${({ layer }) =>
    layer === 2 &&
    `
    top: 0;
    left: 0;
    z-index: 3;
  `}
`;

export const DocumentCardWithFilesWrapper = styled(Box)`
  margin-top: 24px;
`;
